import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, ErrorBanner, Spinner } from '@platform/ui';
import { useLabel } from '@platform/hooks/useLabel';
import { useModulePackage } from './useModulePackage';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';

/**
 * Межа пакета модуля для маршрутів `/:group/:module/*` (ключ модуля — за slug, ADR-028): завантажує пакет (стан, i18n, представлення) перед рендером сторінок модуля.
 * Без пакета ('missing') сторінки працюють на узагальненому рушії; після невдалого завантаження ('error') показує помилку з кнопкою
 * «Повторити» і так само рендерить сторінки на узагальненому рушії (деградований режим, стан списків — у платформному viewState).
 */
export function ModulePackageBoundary() {
  const { module } = useWorkspaceParams();
  const { t } = useTranslation();
  const label = useLabel();
  const pkg = useModulePackage(module);
  if (pkg.status === 'loading') return <Spinner />;
  if (pkg.status !== 'error') return <Outlet />;
  return (
    <>
      <div className="stack" style={{ marginBottom: 12 }}>
        <ErrorBanner error={pkg.error} />
        <div className="row">
          <span className="muted">{t('modules.packageError', { name: label(pkg.manifest?.name) })}</span>
          <Button size="sm" onClick={pkg.retry}>{t('app.retry')}</Button>
        </div>
      </div>
      <Outlet />
    </>
  );
}
